import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FibrePotentialAnalyzerFPA = () => {
  const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1770294042799_Fibre%20Potential%20Analyzer-FPA%20Touch.png?alt=media&token=8d934042-83f7-44f5-986f-dc8f89f71746',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1770294042799_Fibre%20Potential%20Analyzer-FPA%20Touch.png?alt=media&token=8d934042-83f7-44f5-986f-dc8f89f71746'
    ];
    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Fibre Potential Analyzer-FPA Touch</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Fibre Potential Analyzer-FPA Touch</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                  The Fiber Potential Analyzer is an advanced instrument designed for the precise measurement and analysis of fiber properties in various materials, particularly in the field of paper and pulp industries. This cutting-edge device employs innovative technology to assess the quality and characteristics of fibers, providing essential data on parameters such as length, width, and coarseness. By offering a comprehensive understanding of fiber attributes, the Fiber Potential Analyzer plays a crucial role in optimizing production processes, enhancing product quality, and ultimately contributing to the efficiency and competitiveness of the paper and pulp sector.
                                  <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fibre Potential Analyzer-FPA Touch"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}


export default FibrePotentialAnalyzerFPA